import React from 'react';
import {Rnd} from 'react-rnd';
import IconButton from '@mui/material/IconButton';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faXmark} from '@fortawesome/pro-light-svg-icons';

export default class Card extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      width: 200,
      height: 200,
      x: 100,
      y: 200,
    };
  }

  render() {
    return (
      <Rnd
        style={{
          backgroundColor: '#A8DCD9',
          borderRadius: 4,
          boxShadow:
            '0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 5px 8px rgba(0, 0, 0, 0.14), 0px 1px 14px rgba(0, 0, 0, 0.12)',
        }}
        size={{
          width: this.state.width,
          height: this.state.height,
        }}
        position={{
          x: this.state.x,
          y: this.state.y,
        }}
        onDragStop={(e, d) => {
          this.setState({x: d.x, y: d.y});
        }}
        onResizeStop={(e, direction, ref, delta, position) => {
          this.setState({
            width: ref.offsetWidth,
            height: ref.offsetHeight,
            ...position,
          });
        }}
      >
        <div className="text-right p-r-5 p-t-5">
          <IconButton onClick={this.props.onClose}>
            <FontAwesomeIcon icon={faXmark} />
          </IconButton>
        </div>
      </Rnd>
    );
  }
}
